enum WorkspaceProjectState {
  new = 'new',
  in_progress = 'in_progress',
  completed = 'completed',
}

export default WorkspaceProjectState
